import { render } from "./BlView.vue?vue&type=template&id=c7e3e3f0"
import script from "./BlView.vue?vue&type=script&lang=js"
export * from "./BlView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__